// Подразделение, каталог которого может смотреть пользователь (GET /user/subdivisions).
export interface UserSubdivision {
  id: string
  code: string
  name: string
  cityId: string | null
  cityName: string | null
}

export interface UserSubdivisionsRes {
  items: UserSubdivision[]
}

/** «Название, Город» — для профиля и шапки каталога. */
export function formatSubdivision(subdivision: UserSubdivision): string {
  return subdivision.cityName
    ? `${subdivision.name}, ${subdivision.cityName}`
    : subdivision.name
}

/** UUID подразделений сравниваем без учёта регистра. */
export function isSameSubdivision(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  return !!a && !!b && a.toLowerCase() === b.toLowerCase()
}
